import { handleActions } from 'redux-actions';
import {
  cookieInformationAccountInfoFetchInitialized,
  cookieInformationAccountInfoFetchSucceeded,
  cookieInformationAccountInfoFetchFailed,
  cookieInformationAccountCreateSucceeded,
  cookieInformationAccountConnectSucceeded,
  cookieInformationAccountCreateFormShown,
  cookieInformationAccountConnectFormShown,
  CookieInformationAccount,
} from '../CookieInformationService';

export type CookieInformationAccountState =
  | { status: 'awaitingAccountLoad' }
  | { status: 'loadingAccount' }
  | { status: 'showingCreateAccountForm' }
  | { status: 'showingConnectAccountForm' }
  | { status: 'showingCreateAccountSuccess' }
  | { status: 'showingLinkedAccount', accountName: string };

const initialState: CookieInformationAccountState = {
  status: 'awaitingAccountLoad',
};

type CookieInformationAccountPayload = CookieInformationAccount | null;

export default handleActions<CookieInformationAccountState, CookieInformationAccountPayload>({
  [cookieInformationAccountInfoFetchInitialized.toString()]: () => ({
    status: 'loadingAccount',
  }),
  [cookieInformationAccountInfoFetchSucceeded.toString()]: (state, { payload }) => {
    const account = payload as CookieInformationAccount | null;

    return account
      ? { status: 'showingLinkedAccount', accountName: account.accountName }
      : { status: 'showingCreateAccountForm' };
  },
  [cookieInformationAccountInfoFetchFailed.toString()]: () => ({
    status: 'showingCreateAccountForm',
  }),
  [cookieInformationAccountCreateSucceeded.toString()]: () => ({
    status: 'showingCreateAccountSuccess',
  }),
  [cookieInformationAccountConnectSucceeded.toString()]: (state, { payload }) => ({
    status: 'showingLinkedAccount',
    accountName: (payload as CookieInformationAccount).accountName,
  }),
  [cookieInformationAccountCreateFormShown.toString()]: () => ({
    status: 'showingCreateAccountForm',
  }),
  [cookieInformationAccountConnectFormShown.toString()]: () => ({
    status: 'showingConnectAccountForm',
  }),
}, initialState);
